import { useMutation } from "@apollo/react-hooks";
import { createOpportunity as createOpportunityMutation } from "../mutations";
import { GetOpportunities } from "../../../pages/Opportunities/queries";
import { buildGetOpportunitiesVariables } from "../../../pages/Opportunities/helpers";
import { getOwnedProducts } from "../queries";
import { GetSubscriptionLimit } from "../../SubscriptionLimit/queries";

export const useCreateOpportunity = (opportunity, filters) => {
  const variables = !!opportunity && {
    opportunity: buildAddOpportunityVariable(opportunity)
  };

  return useMutation(createOpportunityMutation, {
    variables,
    refetchQueries: [
      {
        query: GetOpportunities,
        ...buildGetOpportunitiesVariables({ filters })
      },
      {
        query: getOwnedProducts
      },
      {
        query: GetSubscriptionLimit
      }
    ]
  });
};

const buildAddOpportunityVariable = ({
  selectedProduct,
  amount,
  isPercentage,
  visibility,
  expiresAt
}) => ({
  product: selectedProduct && selectedProduct.id,
  amount: amount,
  isPercentage,
  visibility: visibility ? "Private" : "Public",
  expiresAt
});
